/** @format — Chat list preview transforms (never use previewMessages as full thread) */

function formatPreviewContent(content) {
  if (content == null) return "";
  if (typeof content === "object") return "";
  return String(content);
}

function mapApiMessageToPreview(msg) {
  const raw = msg.revisions?.[0]?.content ?? msg.content;
  const text = typeof raw === "object" ? JSON.stringify(raw, null, 2) : String(raw ?? "");
  return {
    id: msg.id,
    role: msg.is_agent_message ? "agent" : "user",
    text,
    timestamp: new Date(msg.created_at),
  };
}

/** Sidebar/list item from GET /v1/chats row — preview only, not full history */
export function transformApiChatToListItem(chat, { selectedChatId } = {}) {
  const apiMessages = Array.isArray(chat.messages) ? chat.messages : [];
  const firstUserMessage = apiMessages.find((msg) => !msg.is_agent_message);
  const previewSource = firstUserMessage?.content ?? apiMessages[0]?.content ?? "";

  return {
    id: chat.id,
    sessionId: chat.id,
    title: typeof chat.title === "object" ? JSON.stringify(chat.title) : chat.title || "New Chat",
    preview: formatPreviewContent(previewSource),
    lastMessage: new Date(chat.updated_at || chat.created_at),
    timestamp: new Date(chat.updated_at || chat.created_at),
    isActive: chat.id === selectedChatId,
    previewMessages: apiMessages.map(mapApiMessageToPreview),
  };
}

export function unwrapChatMessagesResponse(res) {
  if (Array.isArray(res)) return res;
  if (Array.isArray(res?.data)) return res.data;
  if (Array.isArray(res?.messages)) return res.messages;
  if (Array.isArray(res?.data?.messages)) return res.data.messages;
  return [];
}

/** Merge a refreshed first page into an already paginated chat list. Preserves scroll order. */
export function mergeChatListUpdates(existing = [], incoming = []) {
  if (!incoming.length) return existing;
  if (!existing.length) {
    return [...incoming].sort(
      (a, b) => new Date(b.lastMessage || b.timestamp).getTime() - new Date(a.lastMessage || a.timestamp).getTime(),
    );
  }

  const incomingById = new Map(incoming.map((chat) => [chat.id, chat]));
  const existingIds = new Set(existing.map((chat) => chat.id));

  const updated = existing.map((chat) =>
    incomingById.has(chat.id) ? { ...chat, ...incomingById.get(chat.id) } : chat,
  );

  const brandNew = incoming.filter((chat) => !existingIds.has(chat.id));
  if (!brandNew.length) return updated;

  return [...brandNew, ...updated];
}
